import { render, staticRenderFns } from "./header.component.html?vue&type=template&id=f8ecccda&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=ts&"
export * from "./Header.vue?vue&type=script&lang=ts&"
import style0 from "./header.component.scss?vue&type=style&index=0&id=f8ecccda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ecccda",
  null
  
)

export default component.exports